"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = void 0;
const react_1 = __importDefault(require("react"));
exports.utils = {
    renderCoverages: (coverages) => {
        return coverages.map((item) => {
            var _a;
            return (react_1.default.createElement("div", { className: "coverage", key: item.name },
                react_1.default.createElement("div", { className: "coverage-name" }, item.name),
                react_1.default.createElement("div", { className: "coverage-value" }, item.value && `$${(_a = item.value) === null || _a === void 0 ? void 0 : _a.toLocaleString("es")}`)));
        });
    },
    renderAssists: (assists) => {
        return assists.map((assist) => {
            return react_1.default.createElement("span", { key: assist },
                "+ ",
                assist);
        });
    }
};
//# sourceMappingURL=utils.js.map